import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import EnquiryForm from "./EnquiryForm";

export default function EnquiryModal({ open, treatment, onClose }) {
  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[90] flex items-end sm:items-center justify-center sm:p-6">
          <motion.div
            data-testid="enquiry-modal-backdrop"
            onClick={onClose}
            className="absolute inset-0 bg-moss/60 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          />
          <motion.div
            data-testid="enquiry-modal"
            role="dialog"
            aria-modal="true"
            className="relative w-full sm:max-w-xl bg-cream rounded-t-3xl sm:rounded-3xl border border-[#E5DDD0] p-8 lg:p-10 max-h-[92vh] overflow-y-auto shadow-2xl"
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 60, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          >
            <button
              data-testid="enquiry-modal-close"
              onClick={onClose}
              aria-label="Close enquiry form"
              className="absolute top-6 right-6 w-9 h-9 rounded-full border border-[#E5DDD0] flex items-center justify-center text-ink/60 hover:text-clay hover:border-clay transition-colors duration-300"
            >
              <X size={16} />
            </button>
            <p className="text-xs uppercase tracking-[0.25em] text-clay font-semibold mb-3">
              Enquire
            </p>
            <h3 className="font-serif text-3xl font-light tracking-tight text-ink mb-2">
              Begin with a conversation.
            </h3>
            <p className="text-sm text-ink/60 mb-8">
              {treatment
                ? `You're enquiring about ${treatment}. We'll reply within 24 hours.`
                : "Tell us a little about your skin — we reply within 24 hours."}
            </p>
            <EnquiryForm
              key={treatment || "general"}
              initialTreatment={treatment}
              idPrefix="modal-enquiry"
              onSuccess={onClose}
            />
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
